import { useEffect } from 'react';

import { useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';
import classNames from 'classnames';
import { FR, US } from 'country-flag-icons/react/3x2';
import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { usePreferences } from '@/react-query/usePreferences';

export const selectedLocaleAtom = atomWithStorage<string | undefined>(
  'jotai-selectedLocale',
  undefined,
);
export const isLocalePickerOpenAtom = atom(false);

export const LocalePicker = () => {
  const [locale, setLocale] = useAtom(selectedLocaleAtom);
  const [isOpen, setIsOpen] = useAtom(isLocalePickerOpenAtom);
  const { i18n } = useLingui();
  const { data: prefs } = usePreferences();

  // set the locale to the selected locale if it exists, otherwise set it to fr-CA (Will need to update when we add more locales)
  useEffect(() => {
    const selectedLocale = localStorage
      .getItem('jotai-selectedLocale')
      ?.replaceAll('"', '');
    if (selectedLocale) {
      setLocale(selectedLocale);
      return;
    }
    if (prefs?.localeSwitcherEnabled) {
      setLocale('fr-CA');
    }
  }, [prefs?.localeSwitcherEnabled, setLocale]);

  useEffect(() => {
    if (locale) {
      i18n.activate(locale);
    }
  }, [locale, i18n]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="!vai-w-auto !vai-p-8">
        <DialogTitle>Select your language</DialogTitle>
        <DialogDescription>
          <div className="vai-flex vai-flex-col vai-gap-2">
            <Button
              className={classNames(locale === 'en' && 'vai-bg-gray-200')}
              variant="icon"
              onClick={() => {
                setLocale('en');
                setIsOpen(false);
              }}
            >
              <US /> English
            </Button>
            <Button
              className={classNames(locale === 'fr-CA' && 'vai-bg-gray-200')}
              variant="icon"
              onClick={() => {
                setLocale('fr-CA');
                setIsOpen(false);
              }}
            >
              <FR /> Français
            </Button>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};
